export default __webpack_public_path__ + "static/media/burkina_faso.bde96621.svg";